module.exports = __webpack_public_path__ + "assets/img/a9084dd2592d7a61a393434185fc405a.svg";